import { Component,Input } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from 'src/app/service/product.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { IProduct } from 'src/app/shared/types/product-d-t';

@Component({
  selector: 'app-shop-area',
  templateUrl: './shop-area.component.html',
  styleUrls: ['./shop-area.component.scss']
})
export class ShopAreaComponent {
  // @Input() shop_right = false;
  public shop_4_col:boolean = false;
  // @Input() shop_3_col = false;

  public products: IProduct[] = [];
  public minPrice: number = 0;
  public maxPrice: number = 250000;
  public brands: string[] = [];
  public category: string | null = null;
  public subcategory: string | null = null;
  public size: string | null = null;
  public color: string | null = null;
  public brand: string | null = null;
  public pageNo: number = 1;
  public pageSize: number = 12;
  public paginate: any = {}; // Pagination use only
  public sortBy: string = 'asc'; // Sorting Order
  filterData:any = null;

  constructor(
    public productService: ProductService,
    public utilsService: UtilsService,
    private route: ActivatedRoute,
    private router: Router,
    private viewScroller: ViewportScroller
  ) {
    this.route.queryParams.subscribe((params) => {
      // console.log('params', params);
      this.minPrice = params['minPrice'] ? params['minPrice'] : this.minPrice;
      this.maxPrice = params['maxPrice'] ? params['maxPrice'] : this.maxPrice;
      this.brand = params['brand'] ? params['brand'] : null;
      this.category = params['category'] ? params['category'] : null;
      this.subcategory = params['subcategory'] ? params['subcategory'] : null;
      this.size = params['size'] ? params['size'] : null;
      this.color = params['color'] ? params['color'] : null;
      this.pageNo = params['page'] ? params['page'] : this.pageNo;
      this.sortBy = params['sortBy'] ? params['sortBy'] : 'asc';
      if(this.category){
        this.productes();
      }

    });
  }

  ngOnInit(){
    //this.filterData = {'minPrice':this.minPrice,'maxPrice':this.maxPrice, }
    this.productes();
  }

  file_path:any = null;
  productes(){
    this.productService.productes(this.category).subscribe({
      next:(res:any) =>{
        //console.log(res);
        if(res.status){

          res.productes.forEach((element:any) => {
            element.path = res.path;
          });
          this.products = res.productes
          this.file_path = res.path;
        }
      },
    })
  }

  // Append filter value to Url
  updateFilter(tags: any) {
    console.log('tags', tags);
  }

  onSortingChange(value: string) {
    this.sortByFilter(value);
  }
  // SortBy Filter
  sortByFilter(value:string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { sortBy: value ? value : null},
      queryParamsHandling: 'merge', // preserve the existing query params in the route
      skipLocationChange: false  // do trigger navigation
    }).finally(() => {
      this.viewScroller.setOffset([120, 120]);
      this.viewScroller.scrollToAnchor('products'); // Anchore Link
    });
  }

  // product Pagination
  setPage(page: number) {
    this.router
      .navigate([], {
        relativeTo: this.route,
        queryParams: { page: page },
        queryParamsHandling: 'merge', // preserve the existing query params in the route
        skipLocationChange: false, // do trigger navigation
      })
      .finally(() => {
        this.viewScroller.setOffset([120, 120]);
        this.viewScroller.scrollToAnchor('products'); // Anchore Link
      });
  }

  handleResetFilter () {
    //this.maxPrice = this.productService.maxPrice;
    this.minPrice = 0;
    this.maxPrice = 450;
    this.brand =  null;
    this.category = null;
    this.subcategory =  null;
    this.size =  null;
    this.color = null;
    this.productes();
    this.router.navigate(['/shop']);
  }
}
